import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom, travelReturnSearchAtom } from "../App";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useEffect, useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import JourneySummary from "../components/Summary/JourneySummary";
import { createJourney } from "../utils/journeyHelpers";

export const ROUND_TRIP = "round_trip";
export const ONEWAY_TRIP = "one_way_trip";

export default function TravelSummary() {

    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    const journeys = [
        createJourney(formData.selectedJourney, "Resa dit", "../vart-vill-ni-resa"),
    ];

    if (formData.selectedReturnJourney && formData.selectedReturnJourney.fromName) {
        journeys.push(
            createJourney(formData.selectedReturnJourney, "Resa tillbaka", "../valj-aterresa"));
    }

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/kontaktuppgifter");

                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"48"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="travelSummaryHeading">Er resa</h2>

                                <p className="mb-0">
                                    Kolla så att allt stämmer om er resa. Behöver du ändra något är det bara att trycka på “Gå tillbaka och ändra”.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <div className="summary-section patient-summary border-0 pb-2">
                                    <div className="summary-data-wrapper flex flex-col">
                                        {journeys.map((journey, index) => (
                                            <JourneySummary
                                                key={index}
                                                journey={journey}
                                                editPath={`/edit/${index}`}
                                                isReturnTravel={journey.Headline.includes("tillbaka")}
                                            />
                                        ))}

                                        {!values.selectedReturnJourney.fromName ? (
                                            <div className="summary-section patient-summary last">
                                                <h3 className="summary-section-heading">Behöver ni resa tillbaka?</h3>

                                                <p>Vi hjälper er gärna att lägga till en resa tillbaka. Hur ni fyllt i resan dit påverkas inte av detta.</p>

                                                <Link className="single-link py-3" to="/valj-aterresa" >
                                                    <FontAwesomeIcon icon={solid("plus")} />
                                                    Lägg till en resa tillbaka
                                                </Link>
                                            </div>
                                        ) : (
                                            <>
                                            </>
                                        )}
                                    </div>
                                </div>

                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
